import type { Block } from '../../../../types/proposal-blocks';

type HeroData = Extract<Block, { type: 'hero' }>;

interface Props {
  block: HeroData;
  onNavigate?: (anchor: string) => void;
  onOpenModal?: () => void;
}

export function HeroBlock({ block, onNavigate, onOpenModal }: Props) {
  return (
    <div className="py-[60px] pb-12 border-b border-proposal-border mb-12">
      {block.eyebrow && (
        <div className="text-[12px] font-semibold text-proposal-fg3 uppercase tracking-widest mb-4 font-proposal-mono">
          {block.eyebrow}
        </div>
      )}
      <h1
        className="text-[clamp(40px,6vw,72px)] font-bold leading-[1.05] tracking-[-0.03em] text-proposal-accent mb-4"
        dangerouslySetInnerHTML={{ __html: block.title.replace(/\n/g, '<br/>') }}
      />
      {block.subtitle && (
        <p className="text-lg text-proposal-fg2 font-normal max-w-[560px] leading-relaxed mb-8">
          {block.subtitle}
        </p>
      )}
      <div className="flex gap-3 flex-wrap">
        {block.cta_primary && (
          <button
            onClick={() => onNavigate?.('')}
            className="bg-proposal-accent text-proposal-accent-text border-none rounded-p-md px-[22px] py-2.5 text-sm font-semibold cursor-pointer transition-opacity hover:opacity-85 font-proposal-ui"
          >
            {block.cta_primary}
          </button>
        )}
        {block.cta_secondary && (
          <button
            onClick={onOpenModal}
            className="bg-transparent text-proposal-fg1 border border-proposal-border-strong rounded-p-md px-[22px] py-2.5 text-sm font-medium cursor-pointer transition-colors hover:bg-proposal-bg3 font-proposal-ui"
          >
            {block.cta_secondary}
          </button>
        )}
      </div>
    </div>
  );
}
